import { ApolloClient, InMemoryCache, from, split } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { onError } from '@apollo/client/link/error'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { getMainDefinition } from '@apollo/client/utilities'
import { createUploadLink } from 'apollo-upload-client'
import { createClient } from 'graphql-ws'

import { ENV } from '../config/env'
import { SITE_KEY } from '../helpers/elements'

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      'Accept-Language': localStorage.lang || 'fa',
      'Content-Type': 'application/json',
      // 'X-Api-Key': 'single:363787a6-26e1-5ed9-92f3-ce664db86686',
      // 'X-Api-Key': 'multi:9f6fc479-03f6-5ed7-8819-62d0d96c1195',
      'X-Api-Key': SITE_KEY,
      ...headers
    }
  }
})
const httpLink = createUploadLink({
  uri: ENV.GRAPH_BFF || 'http://localhost:8080'
})

const wsLink = new GraphQLWsLink(
  createClient({
    url: ENV.GRAPH_BFF_WS || 'ws://localhost:8080/'
  })
)

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  wsLink,
  httpLink
)

const logoutLink = onError(({ response }) => {
  if (
    response?.errors &&
    response.errors.length > 0 &&
    response.errors.some((errorItem) =>
      errorItem.message.toLowerCase().includes('unauthenticated')
    )
  ) {
    // logout();
  }
})

const chainList = [logoutLink, authLink, splitLink]

const linkChain = from(chainList)

const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false
  }),
  link: linkChain
})

export default apolloClient
